// Making a new JS component
// 1 - Replace roleSlider with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var roleSlider = {
    name: "roleSlider",
    componentInitSelector: ".role-slider",
    registerComponent: function () {
        if ($(roleSlider.componentInitSelector).length) {
            framework.registerComponent(roleSlider);
        }
    },
    initroleSlider: function () {
        // Put your args and inits here with their options.

        // End
        log(
            config.application.name +
                " •• roleSlider in " +
                Math.round(
                    performance.now() -
                        framework.initComponents.componentInitTime
                ) +
                " milliseconds"
        );
    },
    init: function () {
        $(".roles-slide").click(function () {
            console.log("video roles");
            var videoSrc = $(this).data("targ-url");

            console.log(videoSrc);
            $(".modalclassvideo").attr("src", videoSrc);
        });

        $("body").on("hidden.bs.modal", ".modal", function () {
            $("video").trigger("pause");
        });

        // End
        roleSlider.initroleSlider();
    },
};

// Register self to the framework
roleSlider.registerComponent();
